import routes from './routes';

export * from './Components/index';
export default routes;
